import { inject } from 'vue'
import mitt from 'mitt'
import Confirm from './Confirm.vue'

export const emitter = mitt()
export const ConfirmSymbol = Symbol()

export function useConfirm() {
	const Confirm = inject(ConfirmSymbol)
	if (!Confirm) {
		throw new Error(`No confirm`)
	}
	return Confirm
}

export const ConfirmPlugin = {
	install: (app) => {
		const ConfirmService = {
			show: (msg, acceptAction = () => ({}), options = {}) => {
				emitter.emit('show', {msg, opts: { ...options, ...{acceptAction}, }})
			},
			hide: () => {
				emitter.emit('hide')
			}
		}

		app.config.globalProperties.$confirm = ConfirmService
		app.component('Confirm', Confirm)
		if (typeof window !== 'undefined') window.$confirm = ConfirmService
		app.provide(ConfirmSymbol, ConfirmService)
	}
}
